// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"9efd1c28","377":"1622f0eb","436":"1ac9a13b","629":"946bd136","787":"627756db"}[chunkId] + ".chunk.js";
};